import React from 'react';
import clsx from 'clsx';

import { useTranslation } from 'react-i18next';

import { Container, Box, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Link from './Link';
import ExternalLink from './EternalLink';

import { footerLinks } from '../config';

const useStyles = makeStyles(theme => ({
  defaultStyle: {
    marginTop: 'auto',
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(2),
    color: theme.palette.primary.contrastText,
  },
}));

const Footer = ({ className, ...props }) => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <Box className={clsx(className, classes.defaultStyle)} {...props}>
      <Container>
        <Grid container spacing={1} direction="row" justifyContent="space-around" alignItems="center">
          {footerLinks.map(({ label, link }) => (
            <Grid key={`footer-item-${label}`} item>
              {link.startsWith('http')
                ? (<ExternalLink label={t(label)} link={link} color="inherit" />)
                : (<Link to={link} color="inherit">{t(label)} </Link>)}
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
